module.exports = __webpack_public_path__ + "img/36_14.0628cfda.png";